import React, { Component } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import { reduxForm } from 'redux-form'
import { PERFIL_ADMIN, getAdminEmpresa, getFiscalEmbarque, getGestorEmpresa, getOperadorEmpresa } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import selecionarAgrupadoDisponibilidadeVeiculo from '../../actions/disponibilidade-veiculo/selecionarAgrupadoDisponibilidadeVeiculo';

export class AgrupadoCalendarioDisponibilidadeVeiculo extends Component {

    exibeAtivo = () => {
        return (
            <input type="checkbox" value={true} checked={true} readOnly={true} />
        );
    }

    render() {
        return <div className="geral">
            <div className="resumo">
                <div className="row">
                    <div className="col">{this.props.agrupadoDisponibilidadesVeiculo.veiculo.descricao}</div>
                    <div className="col">
                        {this.exibeAtivo()}
                    </div>
                    <div className="col">{this.props.agrupadoDisponibilidadesVeiculo.veiculo.mapaVeiculoDto.quantidadeAssentos}</div>
                    <div id='container-botoes' className="col-sm-2 mr-md-n4">
                        <div className='dropdown'>
                            <span className="titulo-mobile">Ações:</span>
                            <button id='menu3pontos' className="btn btn-link btn-acoes btn-sm dropdown" type="button"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className="material-icons">
                                    &#xe5d4;
                                </i>
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <div className="botoes">
                                <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(this.props.empresaSelecionada.id),
                                        getAdminEmpresa(this.props.empresaSelecionada.id),
                                        getOperadorEmpresa(this.props.empresaSelecionada.id),
                                        getFiscalEmbarque(this.props.empresaSelecionada.id)]}>
                                        <button type="button" className="btn btn-editar " title='Calendário'
                                            data-toggle="modal"
                                            data-target="#modalCalendario"
                                            onClick={() => {
                                                this.props.preencherModalCalendario(this.props.agrupadoDisponibilidadesVeiculo);
                                                this.props.selecionarAgrupadoDisponibilidadeVeiculo(this.props.agrupadoDisponibilidadesVeiculo);
                                            }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-calendar" viewBox="0 0 16 16">
                                                <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                                            </svg>
                                        </button>
                                    </Autorizacao>
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(this.props.empresaSelecionada.id),
                                        getAdminEmpresa(this.props.empresaSelecionada.id),
                                        getOperadorEmpresa(this.props.empresaSelecionada.id),
                                        getFiscalEmbarque(this.props.empresaSelecionada.id)]}>
                                        <button type="button" className="btn btn-editar " title='Editar Calendário'
                                            onClick={() => {
                                                this.props.history.push(`/painel-lista-calendario-disponibilidade-veiculo?veiculo=${this.props.agrupadoDisponibilidadesVeiculo.veiculo.id}`)
                                            }}>
                                            <i className="material-icons nav-icon">&#xe150;</i>
                                        </button>
                                    </Autorizacao>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

export const mapStateToProps = state => (
    {
        empresaSelecionada: state.empresaSelecionada,
    });

export default withRouter(connect(mapStateToProps, {
    selecionarAgrupadoDisponibilidadeVeiculo
})(reduxForm({
    form: 'formularioCalendarioDisponibilidadeVeiculo'
})(AgrupadoCalendarioDisponibilidadeVeiculo)))